import React from "react";
import { Button, CircularProgress, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LoadMoreButton = ({ 
  onLoadMore, 
  loading = false, 
  hasMore = true, 
  totalLoaded = 0,
  disabled = false 
}) => {
  const { t } = useTranslation();

  if (!hasMore) {
    return (
      <Box 
        sx={{ 
          display: "flex", 
          justifyContent: "center", 
          padding: "20px",
          color: "#666"
        }}
      >
        <Typography variant="body2">
          {t("AllResultsLoaded") || "All results loaded"}
        </Typography>
      </Box>
    );
  }

  return (
    <Box 
      sx={{ 
        display: "flex", 
        justifyContent: "center", 
        padding: "20px" 
      }}
    >
      <Button
        variant="outlined"
        onClick={onLoadMore}
        disabled={loading || disabled}
        sx={{
          minWidth: "160px",
          height: "48px",
          borderColor: "#1976d2",
          color: "#1976d2",
          "&:hover": {
            borderColor: "#115293",
            backgroundColor: "#f5f5f5"
          },
          "&:disabled": {
            borderColor: "#ccc",
            color: "#999"
          }
        }}
        aria-label={loading ? t("Loading") || "Loading more results" : t("LoadMore") || "Load more results"}
      >
        {loading ? (
          <>
            <CircularProgress size={20} sx={{ marginRight: "8px" }} />
            {t("Loading") || "Loading..."}
          </>
        ) : (
          t("LoadMore") || "Load More"
        )}
      </Button>
    </Box>
  );
};

export default LoadMoreButton;